import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Phone, Mail } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#050505] border-t border-[#C9A84C]/10 py-20">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <h3 className="text-[#C9A84C] font-serif text-xl mb-4">{t('brand')}</h3>
            <p className="text-[#A3A3A3] text-sm leading-relaxed">
              {t('hero.subtitle')}
            </p>
          </div>

          <div>
            <h4 className="text-[#F5F2EB] text-sm uppercase tracking-wider mb-4">{t('footer.aboutUs')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                  {t('about')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                  {t('contact')}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                  {t('blog')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#F5F2EB] text-sm uppercase tracking-wider mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/astrology" className="text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                  {t('astrology')}
                </Link>
              </li>
              <li>
                <Link to="/vastu" className="text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                  {t('vastu')}
                </Link>
              </li>
              <li>
                <Link to="/horoscope" className="text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                  Daily Horoscope
                </Link>
              </li>
              <li>
                <Link to="/kundli" className="text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                  Free Kundli
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#F5F2EB] text-sm uppercase tracking-wider mb-4">{t('footer.legal')}</h4>
            <ul className="space-y-2 mb-6">
              <li>
                <Link to="/disclaimer" className="text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                  {t('footer.disclaimer')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                  {t('footer.privacy')}
                </Link>
              </li>
            </ul>
            <div className="space-y-2">
              <a href="tel:8099975662" className="flex items-center gap-2 text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                <Phone className="w-4 h-4" />
                8099975662
              </a>
              <a href="mailto:astrologytimes5@gmail.com" className="flex items-center gap-2 text-[#A3A3A3] hover:text-[#C9A84C] text-sm transition-colors">
                <Mail className="w-4 h-4" />
                astrologytimes5@gmail.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#C9A84C]/10 text-center">
          <p className="text-[#A3A3A3] text-sm">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;